import React from 'react';

/**
 * Full-screen modal loading overlay with a Mintek-red spinner.
 * Renders nothing when `show` is false — safe to leave mounted.
 *
 * Usage:
 *   const [loading, setLoading] = useState(false);
 *   ...
 *   <LoadingOverlay show={loading} message="Loading project..." />
 */
export default function LoadingOverlay({ show = true, message = 'Loading...' }) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl px-8 py-6 flex flex-col items-center gap-3 min-w-[220px]">
        <div className="w-10 h-10 border-4 border-slate-200 border-t-[#c8102e] rounded-full animate-spin" />
        <p className="text-sm font-semibold text-slate-700">{message}</p>
      </div>
    </div>
  );
}
